import { Container } from "@mui/material";
import PromotionalCard from "../CommonComponents/PromotionalCard";
import { useContext } from "react";
import { LocalizationContext } from "../../lib/context";
import { useUserData } from "../../hooks/useUserData";

const InspirationsCommunities = () => {
  const { user } = useUserData();
  const { promoCards } =
    useContext(LocalizationContext).localeStrings.uiGeneral;
  const jobsData = promoCards.filter((c) => c.promoId === "jobs")[0];
  const joinData = promoCards.filter((c) => c.promoId === "join")[0];
  const discountsData = promoCards.filter((c) => c.promoId === "discounts")[0];
  return (
    <Container className="inspire__communities">
      <PromotionalCard
        title={jobsData.title}
        content={jobsData.description}
        imgUrl="/assets/cottonbro.jpeg"
        btnContent={jobsData.buttonText}
        left
        dark
        link="/jobs"
      />
      {!user && (
        <PromotionalCard
          title={joinData.title}
          content={joinData.description}
          imgUrl="/assets/unsplash.jpeg"
          btnContent={joinData.buttonText}
          dark
          imgHeight={200}
          link="/register"
        />
      )}
      <PromotionalCard
        title={discountsData.title}
        content={discountsData.description}
        imgUrl="/assets/tembela.jpeg"
        btnContent={discountsData.buttonText}
        left
        dark
        link="/discounts"
      />
    </Container>
  );
};

export default InspirationsCommunities;
